module.exports = __webpack_public_path__ + "img/do_not_disturb.334cbb58.svg";